import React, {useCallback} from 'react';
import {Grid, Typography, Fab, Box, useTheme, Stack} from '@mui/material';

import LoadingButton from '@mui/lab/LoadingButton';
import AddIcon from '@mui/icons-material/Add';
import {RHFAutocomplete, RHFTextField} from '@components/hook-form';
import {useForm} from 'react-hook-form';

import FormProvider from 'src/minimal-components/hook-form/form-provider';
import {enqueueSnackbar} from 'notistack';
import {useResponsive} from 'src/hooks/use-responsive';
import {
  getSearchForm,
  postCourseData
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import EncryptUtils from 'src/utils/EncryptUtils';
import ProductListView from './cmsDatagrid';
import {useTranslation} from 'react-i18next';
import {display} from '@mui/system';
import {
  BASE_RECORD_ID,
  BASE_LEGACY_APP,
  BASE_SPECIMEN_NUMBER,
  BASE_SPECIMEN_NUMBER_ID,
  BASE_SPECIMEN_TYPE,
  BASE_DEMOGRAPHIC_ID,
  BASE_PROCEDURE_ID,
  LMS_TYPE,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  PARAMS_KEY,
  LMS_IS_ADMIN
} from 'src/routes/BaseRoute';
import FormConstants from '@shared/constants/FormConstants';
import {useNavigate} from 'react-router-dom';
import {useBoolean} from 'src/hooks/use-boolean';
import CreateCourse from './CreateCourse';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {ba} from '@fullcalendar/core/internal-common';
import {useModulePreviewContext} from '@context/ModulePreviewContextProvider';
import {Pagination} from '@supabase/supabase-js';
interface CourseCatalogComponentProps {
  module: string;
  handleEditUser?: (data: any) => void;
  handleNewUser?: (data: any) => void;
  handleViewUser?: (data: any) => void;
}
interface CourseStatusOption {
  label: string;
  value: string;
}
interface FormData {
  Coursename: string;
  CreatedBy: string;
  status: string;
}
interface CourseTableData {
  id: string;
  Code: string;
  CourseName: string;
  CourseType: string;
  Duration: string;
  publish: string;
  CreatedAt: Date | number | string;
  ModifiedAt: Date | number | string;
  CreatedBy: string;
  ModifiedBy: string;
}

const Courseinitial = (
  Props: CourseCatalogComponentProps
): React.ReactElement => {
  const {handleEditUser, handleNewUser, handleViewUser} = Props;
  const USER_TABLE_KEY = 'User';
  const ADMIN_TABLE_KEY = 'Admin';
  const methods = useForm();
  const {reset, handleSubmit} = methods;
  const mdUp = useResponsive('up', 'md');
  const theme = useTheme();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [UIFieldsData, setUIFieldsData] = React.useState<any>([]);
  const [Permissions, setPermissions] = React.useState<any>([]);
  const [loader, setLoader] = React.useState<boolean>(false);
  const [isloading, setisloading] = React.useState<boolean>(false);
  const [initialResponse, setInitialResponse] = React.useState<any>();
  const {SetModulePreviewData} = useModulePreviewContext();
  const [tablesloader, setTablesLoader] = React.useState<
    Record<string, boolean>
  >({
    [USER_TABLE_KEY]: false,
    [ADMIN_TABLE_KEY]: false // default
  });
  const [tablesPagination, setTablesPagination] = React.useState<
    Record<string, {page: number; pageSize: number}>
  >({
    [USER_TABLE_KEY]: {page: 0, pageSize: 10},
    [ADMIN_TABLE_KEY]: {page: 0, pageSize: 10} // default
  });
  const [tableAdminData, setTableAdminData] = React.useState<CourseTableData[]>(
    []
  );
  const [tableAdmincountdata, setTableAdminDataCount] =
    React.useState<number>(0);
  const [tableUserData, setTableUserData] = React.useState<CourseTableData[]>(
    []
  );
  const [tableUsercountdata, setTableUserDataCount] = React.useState<number>(0);

  const [statusOptions, setStatusOptions] = React.useState<
    CourseStatusOption[]
  >([]);
  const [formerror, setFormerror] = React.useState<string>('');
  const [searchData, setSearchData] = React.useState<FormData>({
    Coursename: '',
    CreatedBy: '',
    status: ''
  });
  const newFolder = useBoolean();
  const getTableData = async (
    res: any,
    type: string,
    pagination: {page: number; pageSize: number}
  ) => {
    try {
      if (res || initialResponse) {
        const {page, pageSize} = pagination;
        if (type === ADMIN_TABLE_KEY) {
          setTablesLoader(prev => ({...prev, [type]: true}));
          const data = {...searchData, page, pageSize};
          console.info('DATA2nd', res, data);

          const encryptRequestData = EncryptUtils.encryptedData(
            res || initialResponse
          );
          const apidata = await postCourseData(
            'LMS',
            'course_management',
            {
              tk: encryptRequestData,
              values: data
            },
            'getTabledata'
          );
          console.info('DATA2nd', apidata);
          await setTableAdminData(apidata.data);
          if (apidata?.count[0]?.counts) {
            setTableAdminDataCount(apidata.count[0].counts);
          }
          setTablesLoader(prev => ({...prev, [type]: false}));
        }
        if (type === USER_TABLE_KEY) {
          setTablesLoader(prev => ({...prev, [type]: true}));
          const data = {...searchData, page, pageSize};
          console.info('DATA2nd', res, data);
          const encryptRequestData = EncryptUtils.encryptedData(
            res || initialResponse
          );
          const apidata = await postCourseData(
            'LMS',
            'course_management',
            {
              tk: encryptRequestData,
              values: data
            },
            'getUserTabledata'
          );
          console.info('DATA2nd', apidata);
          await setTableUserData(apidata.data);
          if (apidata?.count[0]?.counts) {
            setTableUserDataCount(apidata.count[0].counts);
          }
          setTablesLoader(prev => ({...prev, [type]: false}));
        }
      }
    } catch (e) {
      setTablesLoader(prev => ({...prev, [type]: false}));
    }
  };
  const init = async () => {
    try {
      if (Props.module) {
        setLoader(true);
        const res = await getSearchForm('LMS', 'course_management');
        console.info('DATA', res);
        await setInitialResponse(res.data);
        setPermissions(res.perm);
        setUIFieldsData(res.data.searchForm?.fields);

        if (
          res.perm.find(
            (item: {function_label: string}) =>
              item.function_label === 'showSearch'
          )
        ) {
          setStatusOptions(
            res.data.searchForm?.fields.status.drop_down_options[0]?.status ||
              []
          );
        } else if (
          res.perm.find(
            (item: {function_label: string}) =>
              item.function_label === 'showAdminTable'
          )
        ) {
          await getTableData(
            res.data,
            ADMIN_TABLE_KEY,
            tablesPagination[ADMIN_TABLE_KEY]
          );
        }
        if (
          res.perm.find(
            (item: {function_label: string}) =>
              item.function_label === 'showUserTable'
          )
        ) {
          await getTableData(
            res.data,
            USER_TABLE_KEY,
            tablesPagination[USER_TABLE_KEY]
          );
        }
        setLoader(false);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };
  React.useEffect(() => {
    SetModulePreviewData([]);
    init();
  }, []);
  const handlePaginationChange = (
    tableKey: string,
    model: {page: number; pageSize: number}
  ) => {
    setTablesPagination(prev => ({...prev, [tableKey]: model}));

    // 🔔 kick off the API call for *that* table
    getTableData(initialResponse, tableKey, {
      page: model.page * model.pageSize, // If you’re using offset-based pagination
      pageSize: model.pageSize
    });
  };
  const editUser = (data: any): void => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: data,
      [LMS_TYPE]: 'edit',
      [LMS_IS_ADMIN]: 'True'
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=overview`,
      {
        state: {}
      }
    );
  };
  const viewUser = (data: any, type: string): void => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: data,
      [LMS_TYPE]: 'view',
      [LMS_IS_ADMIN]: type === 'Admin' ? 'True' : 'False'
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=overview`,
      {
        state: {}
      }
    );
  };
  const handleaddnewCourse = (data: number) => {
    // console.log('CreateCourse', data);

    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: data,
      [LMS_TYPE]: 'new',
      [LMS_IS_ADMIN]: 'True'
    });
    const url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=overview`;
    navigate(url);
    newFolder.onFalse();
  };
  const handleCreateNewFolder = useCallback(
    (value: number) => {
      handleaddnewCourse(value);

      console.info('CREATE NEW FOLDER');
    },
    [newFolder]
  );
  const getData = async () => {
    if (initialResponse) {
      const encryptRequestData = EncryptUtils.encryptedData(initialResponse);
      const apidata = await postCourseData(
        'LMS',
        'course_management',
        {
          tk: encryptRequestData,
          values: searchData
        },
        'getTabledata'
      );
      console.info('DATA2nd', apidata);
      await setTableAdminData(apidata.data);
      if (apidata?.count[0]?.counts) {
        setTableAdminDataCount(apidata.count[0].counts);
      }
    }
  };
  // const handleDeleteItem = async (id: any) => {
  //   console.log('Delete Item', id);
  // };
  const publicChange = async (id: any) => {
    console.log('Publish Change initial page', id);
    // try {
    //   const publishChange = await postCourseData(
    //     'LMS',
    //     'course_management',
    //     {
    //       tk: initialResponse,
    //       values: {id: id}
    //     },
    //     'publishChange'
    //   );
    //   console.log('Publish Change', publishChange);
    //   if (publishChange.data === 'Success') {
    //     enqueueSnackbar(
    //       'Course Published Successfully',
    //       SnackBarConfig.getSuccess()
    //     );
    //     getData();
    //   }
    // } catch (error) {
    //   console.error(error);
    // }
  };
  const deleteUser = async (data: any) => {
    try {
      if (initialResponse) {
        const encryptRequestData = EncryptUtils.encryptedData(initialResponse);
        const deletedvalue = await postCourseData(
          'LMS',
          'course_management',
          {
            tk: encryptRequestData,
            values: data
          },
          'deleteCourse'
        );
        if (deletedvalue.data === 'Success') {
          enqueueSnackbar(
            'Course Deleted Successfully',
            SnackBarConfig.getSuccess()
          );
          getData();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onSubmit = async (data: any) => {
    let atLeastOneFieldEmpty = false;
    const present = Object.entries(searchData).length;
    let count = 0;
    Object.entries(searchData).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) {
        count = count + 1;
      }
    });
    if (count === present) {
      atLeastOneFieldEmpty = true;
    }
    try {
      if (atLeastOneFieldEmpty) {
        setFormerror('Please enter some values to search');
        // if (handleEmptyRequest) handleEmptyRequest();
      } else {
        setFormerror('');
        setisloading(true);
        if (initialResponse) {
          const encryptRequestData =
            EncryptUtils.encryptedData(initialResponse);
          const apidata = await postCourseData(
            'LMS',
            'course_management',
            {
              tk: encryptRequestData,
              values: searchData
            },
            'getTabledata'
          );
          await setTableAdminData(apidata.data);
          if (apidata?.count[0]?.counts) {
            setTableAdminDataCount(apidata.count[0].counts);
          }
        }
        setisloading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const renderActions = (
    <>
      {mdUp && <Grid md={4} />}
      <Grid
        xs={12}
        md={8}
        sx={{
          display: 'flex',
          alignItems: 'center',
          margin: '2vh 0',
          justifyContent: 'flex-end'
        }}>
        <LoadingButton
          type="reset"
          variant="outlined"
          onClick={e => {
            reset;
            setFormerror('');
            setTableAdminData([]);
            setTableAdminDataCount(0);
            setSearchData({
              Coursename: '',
              CreatedBy: '',
              status: ''
            });
          }}
          sx={{
            mr: 2,
            backgroundColor: theme.palette.primary.light
          }}>
          Clear
        </LoadingButton>
        <LoadingButton
          type="submit"
          variant="contained"
          loading={isloading}
          sx={{
            // mr: 2,
            backgroundColor: theme.palette.primary.dark
          }}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            handleSubmit(onSubmit)();
          }}>
          Search
        </LoadingButton>
      </Grid>
    </>
  );

  return (
    <>
      {loader ? (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'50vh'}>
          <LoadingScreen />
        </Stack>
      ) : (
        <>
          {Permissions?.find(
            (item: {function_label: string}) =>
              item.function_label === 'showSearch'
          ) && (
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
              <Box
                sx={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: '3vh'
                }}>
                <Grid
                  container
                  xs={12}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    pb: '3vh',
                    marginTop: '1vh'
                  }}>
                  <Typography variant="h1" gutterBottom>
                    My Courses
                  </Typography>
                  <div style={{paddingRight: '5vh'}}>
                    <Fab
                      color="primary"
                      aria-label="add"
                      size="small"
                      onClick={() => {
                        newFolder.onTrue();
                        // handleaddnewCourse('new')
                      }}>
                      <AddIcon />
                    </Fab>
                  </div>
                </Grid>
                {UIFieldsData.length !== 0 && (
                  <Grid
                    rowGap={3}
                    columnGap={2}
                    display="grid"
                    gridTemplateColumns={{
                      xs: 'repeat(1, 1fr)',
                      sm: 'repeat(3, 1fr)'
                    }}>
                    <Stack spacing={1.5}>
                      <Typography variant="subtitle2">
                        {UIFieldsData?.course_name.heading[0]}
                      </Typography>
                      <RHFTextField
                        name="Coursename"
                        placeholder={UIFieldsData.course_name.placeholder[0]}
                        // defaultValue={searchData.Coursename}
                        value={searchData.Coursename}
                        onChange={e => {
                          setSearchData(prevState => ({
                            ...prevState,
                            Coursename: e.target.value
                          }));
                        }}
                      />
                    </Stack>

                    <Stack spacing={1.5}>
                      <Typography variant="subtitle2">Status</Typography>
                      {statusOptions !== null && (
                        <RHFAutocomplete
                          name="status"
                          placeholder="status"
                          defaultValue={searchData.status}
                          value={searchData.status}
                          onChange={(e: any) => {
                            if (e.target.textContent)
                              setSearchData(prevState => ({
                                ...prevState,
                                status: e.target.textContent
                              }));
                          }}
                          options={
                            statusOptions as readonly CourseStatusOption[]
                          }
                          getOptionLabel={(
                            option: string | CourseStatusOption
                          ) => {
                            if (typeof option === 'string') {
                              return option;
                            }
                            return option.label;
                          }}
                        />
                      )}
                    </Stack>
                    <Stack spacing={1.5}>
                      <Typography variant="subtitle2">
                        {UIFieldsData?.created_by.heading[0]}
                      </Typography>
                      <RHFTextField
                        name="CreatedBy"
                        value={searchData.CreatedBy}
                        // defaultValue={searchData.CreatedBy}
                        placeholder={UIFieldsData?.created_by.placeholder[0]}
                        onChange={e => {
                          setSearchData(prevState => ({
                            ...prevState,
                            CreatedBy: e.target.value
                          }));
                        }}
                      />
                    </Stack>
                  </Grid>
                )}
                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                  <Box
                    sx={{color: 'red', alignItems: 'center', display: 'flex'}}>
                    {formerror}
                  </Box>
                  {renderActions}
                </Box>
              </Box>
            </FormProvider>
          )}
          {tableAdminData.length === 0 && tableUserData.length === 0 ? (
            !loader &&
            !initialResponse?.searchForm?.showSearch && (
              <Stack
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                sx={{backgroundColor: 'white'}}
                minHeight={'80vh'}>
                <Box>
                  <Typography variant="h1" gutterBottom>
                    The courses were not assigned
                  </Typography>
                </Box>
              </Stack>
            )
          ) : (
            <>
              {tableAdminData.length !== 0 && (
                <ProductListView
                  key={ADMIN_TABLE_KEY} // in case you map over many tables
                  tableKey={ADMIN_TABLE_KEY}
                  products={tableAdminData}
                  tableViewFormat={true}
                  paginationModel={tablesPagination[ADMIN_TABLE_KEY]}
                  loaders={tablesloader[ADMIN_TABLE_KEY]}
                  totalRowCount={tableAdmincountdata} // optional, improves paging UI
                  onPaginationModelChange={handlePaginationChange}
                  handleEditUser={editUser}
                  handleDeleteUser={deleteUser}
                  handlePublishChange={publicChange}
                  handleViewUser={viewUser}
                />
              )}
              {tableUserData.length !== 0 && (
                <ProductListView
                  key={USER_TABLE_KEY} // in case you map over many tables
                  tableKey={USER_TABLE_KEY}
                  products={tableUserData}
                  tableViewFormat={false}
                  paginationModel={tablesPagination[USER_TABLE_KEY]}
                  loaders={tablesloader[USER_TABLE_KEY]}
                  totalRowCount={tableUsercountdata} // optional, improves paging UI
                  onPaginationModelChange={handlePaginationChange}
                  handleEditUser={editUser}
                  handleDeleteUser={deleteUser}
                  handlePublishChange={publicChange}
                  handleViewUser={viewUser}
                />
              )}
            </>
          )}
        </>
      )}
      <CreateCourse
        open={newFolder.value}
        onClose={newFolder.onFalse}
        title="New Course"
        onCreate={handleCreateNewFolder}
      />
    </>
  );
};

export default Courseinitial;
